"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _Slider = _interopRequireDefault(require("@eig-builder/core-ui/Slider"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _Tooltip = _interopRequireDefault(require("@eig-builder/core-ui/Tooltip"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var ImageDetailsEffectBox = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n"])));

var ImageDetailsEffectTitleBox = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  border-bottom: 1px solid transparent;\n  padding: 0 10px;\n  display: flex;\n  align-items: center;\n"])));

var EffectBox = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 2px 10px;\n  p {\n    text-transform: capitalize;\n  }\n"])));

var ResetIconBox = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  text-align: center;\n  font-size: 11px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  padding: 0px 4px;\n  height: 25px;\n  margin-left: 4px;\n  color: ", ";\n  span {\n    height: 11px;\n  }\n  &:hover {\n    /* border: 1px solid #e1e1e1; */\n    /* border-radius: 3px; */\n    color: ", ";\n  }\n"])), function (props) {
  return props.theme.palette.black.main;
}, function (props) {
  return props.theme.palette.black.dark;
});

var availableEffects = ['hue', 'contrast', 'brightness', 'intensity'];

var ImageEffectSlider = function ImageEffectSlider(_ref) {
  var name = _ref.name,
      defaultValue = _ref.defaultValue,
      minValue = _ref.minValue,
      maxValue = _ref.maxValue,
      value = _ref.value,
      set = _ref.set;

  var onChangedValue = function onChangedValue(newEffectValue, name) {
    set(name, newEffectValue, true);
  };

  return /*#__PURE__*/_react["default"].createElement(EffectBox, null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body2"
  }, name), /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    onChange: function onChange(e, newValue) {
      return onChangedValue(newValue, name);
    },
    defaultValue: defaultValue,
    value: value,
    step: 0.1,
    min: minValue,
    max: maxValue
  }));
};

ImageEffectSlider.propTypes = {
  name: _propTypes["default"].string.isRequired,
  defaultValue: _propTypes["default"].number.isRequired,
  minValue: _propTypes["default"].number.isRequired,
  maxValue: _propTypes["default"].number.isRequired,
  value: _propTypes["default"].number.isRequired,
  set: _propTypes["default"].func.isRequired
};

var ImageDetailsEffects = function ImageDetailsEffects(_ref2) {
  var options = _ref2.options,
      set = _ref2.set,
      reset = _ref2.reset,
      values = _ref2.values,
      getValue = _ref2.getValue;
  var suggestedOptions = options.filter(function (option) {
    return availableEffects.indexOf(option.name) > -1;
  });
  return /*#__PURE__*/_react["default"].createElement(ImageDetailsEffectBox, null, /*#__PURE__*/_react["default"].createElement(ImageDetailsEffectTitleBox, null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h4"
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.editImages.titleColors"
  })), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: "imagepicker.editImages.resetEffects"
    }),
    placement: "top"
  }, /*#__PURE__*/_react["default"].createElement(ResetIconBox, {
    onClick: reset
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "replay"
  })))), suggestedOptions.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement(ImageEffectSlider, (0, _extends2["default"])({}, option, {
      key: index,
      set: set,
      value: values[option.name] || getValue(option.name)
    }));
  }));
};

ImageDetailsEffects.propTypes = {
  options: _propTypes["default"].array,
  set: _propTypes["default"].func.isRequired,
  reset: _propTypes["default"].func.isRequired,
  values: _propTypes["default"].any,
  getValue: _propTypes["default"].func.isRequired
};
var _default = ImageDetailsEffects;
exports["default"] = _default;